import React, { useEffect, useRef, useState } from "react";
import { getVideoDetails } from "./service"
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import VideoJS from '../../Components/VideoJsPlayer/VideoJS';
import { convertAdUrl, getEventInfo, imageUrlCheck, isHTML, onVideoPlayFunction } from "../../utils/utils";
import { getUserSubscriptionData } from "../../Redux/UserSubscriptionDetails/userSubscriptionSlice";
import { getPlayerToken, updateVideoWatchlistData, getUserSubscription, updateWatchlistData, authenticate } from "../../network/service";
import { getMoreInfoOther } from "../../Redux/MoreInfo/moreInfoOtherSlice";
import { getMoreInfo } from "../../Redux/MoreInfo/moreInfoSlice";
import { getUser } from "../../Redux/UserSlice/UserSlice";
import { getAccessToken } from "../../Redux/AToken/ATokenSlice";
import ContinueWatchingModel from "../../Components/Modals/ContinueWatchingModel";
import Loading from "../../Components/Loading/Loading";
import { ReactComponent as LeftArrow } from "../../assets/Icons/leftArrow.svg";
import ShowCard from "../../Components/ShowCard/ShowCard";
import Select from "react-select";
import Comment from "./Components/Comment"
import Autoplay from "./Components/Autoplay";
import LogoutAllModal from "../../Components/Modals/LogoutAllModal";
import parse from "html-react-parser";
import Translate from "../../Components/Multilanguage/Translate";
import CalendarPopup from "../Calendar/components/CalendarPopup";
// import { createBrowserHistory } from 'history';

let debounce = true;
var videoStarted = false;
let seconds = 60;
let prevTime;
let videoPlaying = false;
let playEventSent = false;
let wasPaused = false;

function VideoPlayer() {
    const location = useLocation()
    const videoId = location?.state?.videoDetails?.video_id;
    const { vanityUrl } = useParams()
    const datas = location?.state?.data;
    const showName = location?.state?.showname;
    const thumbnailOrientation = location?.state?.thumbnailOrientation;
    const projectInfo = useSelector((state) => state?.projectInfo?.value);
    const accessToken = useSelector((state) => state?.accessToken?.value);
    const sessionId = useSelector((state) => state?.sessionId?.value);
    const user = useSelector((state) => state?.user?.value);
    const isLive = location?.state?.isLive;
    const isMoreInfoOther = useSelector((state) => state?.moreInfoOther?.value);
    const ai_type = useSelector((state) => state?.aiType?.value);

    const [videoUrl, setVideoUrl] = useState();
    const [adUrl, setAdUrl] = useState("");
    const [videoDetails, setVideoDetails] = useState();
    const [videoTitle, setVideoTitle] = useState("");
    const [poster, setPoster] = useState("");
    const [loading, setLoading] = useState(true);
    const [watchListStatus, setWatchListStatus] = useState();
    const [vPlayer, setVPlayer] = useState();
    const [isContinueWatchingModal, setIsContinueWatchingModal] = useState(false);
    const [showVideo, setShowVideo] = useState(false);
    const [subtitleInfo, setSubTitleInfo] = useState();
    const [videoResolutionInfo, setVideoResolutionInfo] = useState();
    const [closedCaptionInfo, setClosedCaptionInfo] = useState()
    const [watchedDuration, setWatchedDuration] = useState();
    const [isAutoplayView, setIsAutoplayView] = useState(false);
    const [watchedTime, setWatchedTime] = useState(0)
    const [multiLanguageOptions, setMultiLanguageOptions] = useState([])
    const [selectedAudioLanguage, setSelectedAudioLanguage] = useState({})
    const [upNext, setUpNext] = useState([])
    const [isFree, setIsFree] = useState(false);
    const [isPremium, setIsPremium] = useState(false);
    const [userSubscriptionData, setUserSubscriptionData] = useState([]);
    const [modalType, setModalType] = useState({ type: "logoutAll" });
    const [logoutModal, setLogoutModal] = useState(false);
    const [showCalendarPopup, setShowCalendarPopup] = useState(false);

    const playerRef = useRef(null);
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const showDetails = location?.state?.showDetails
    const showId = showDetails?.show_id;
    const videoType = location?.state?.showDetails?.type === "linear_event" ? "event" : "video";
    let showUniqueId = isMoreInfoOther?.showId ? isMoreInfoOther?.showId : showId;
    const continueWatch = location?.state?.continue;
    const watchDuration = location?.state?.videoDetails?.watched_duration;
    const template = projectInfo?.projectConfig?.config?.TEMPLATE;
    const theme = projectInfo?.projectConfig?.config?.THEME;
    const customStyles = {
        control: (provided, state) => ({
            ...provided,
            backgroundColor: 'transparent',
            '&:hover': {
                borderColor: 'grey',
            },

        }),

        menu: (provided) => ({
            ...provided,
            top: 'auto',
            bottom: '100%',
            backgroundColor: 'grey',
        }),

        singleValue: (provided) => ({
            ...provided,
            color: theme === 'LIGHT' ? 'black' : 'white',
        }),

        placeholder: (provided) => ({
            ...provided,
            color: theme === 'LIGHT' ? 'black' : 'white',
        }),
    };

    const appInfo = {
        projectDetails: projectInfo,
        accessToken: accessToken,
        sessionId,
    };
    useEffect(() => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        })
        setVPlayer(null)
        setLoading(true)
        setSelectedAudioLanguage({})

        fetchVideoDetails();
    }, [location?.pathname]);

    useEffect(() => {
        setAdUrl(convertAdUrl(videoDetails, showDetails, appInfo, isLive));
        playVideo();
    }, [videoDetails]);

    useEffect(() => {
        setVPlayer(null);
        if ((!isContinueWatchingModal || continueWatch) && videoUrl) {
            const videoJsOptions = {
                autoplay: false,
                controls: true,
                responsive: true,
                fluid: true,
                bigPlayButton: true,
                controlBar: {
                    pictureInPictureToggle: false,
                },
                sources: [
                    {
                        src: `${videoUrl}`,
                        type: "application/x-mpegURL",
                    },
                ],
            };

            setVPlayer(
                <VideoJS
                    options={videoJsOptions}
                    onReady={handlePlayerReady}
                    adUrl={adUrl ? adUrl : null}
                    subtitles={subtitleInfo}
                    poster={poster}
                    videoResolutionInfo={videoResolutionInfo}
                    videoUrl={videoUrl}
                />
            );
        }
    }, [videoUrl]);

    useEffect(() => {

        if (continueWatch && watchDuration > 0) {
            setIsContinueWatchingModal(false);
            playVideo(watchDuration);

        } else {
            //nothing to do
        }
    }, [continueWatch, watchDuration]);

    useEffect(() => {
        logoutLimitCheck();
    }, [userSubscriptionData]);


    const handleClose = () => {
        document.body.className = "hideScroll";
        if (isMoreInfoOther?.isModal) {
            if (isMoreInfoOther?.isFromSearch) {
                if (location?.state?.isFromHome) {
                    navigate("/");
                }
                setTimeout(() => {
                    dispatch(
                        getMoreInfoOther({
                            isModal: false,
                            showId: null,
                            isFromSearch: false,
                        })
                    );
                }, 600);
            } else {
                setTimeout(() => {
                    dispatch(
                        getMoreInfoOther({
                            isModal: false,
                            showId: null,
                        })
                    );
                }, 600);
            }
        } else {
            setTimeout(() => {
                dispatch(
                    getMoreInfo({
                        moreInfo: false,
                    })
                );
            }, 500);
        }

    };
    const redirectToLogin = () => {
        dispatch(
            getUser({
                user: null,
            })
        );
        localStorage.removeItem("userId");
        tokenAuthenticate();
        navigate("/login", {
            state: { path: location?.pathname, showId: showUniqueId },
        });
    };
    const fetchUserSubscriptionDetails = async () => {
        const userSubResponse = await getUserSubscription(appInfo);
        if (userSubResponse?.status === 200) {

            setUserSubscriptionData(userSubResponse?.data);
            dispatch(
                getUserSubscriptionData({
                    userSubscription: userSubResponse?.data,
                })
            );
        }
    };

    const updateVideoAnalytics = async (event, time, ai_type) => {
        const updateResponse = await onVideoPlayFunction(
            appInfo,
            videoDetails,
            event,
            time,
            "0",
            location?.state?.categories,
            showDetails?.show_id,
            ai_type
        );
    };

    const fetchVideoDetails = async () => {
        try {
            await fetchUserSubscriptionDetails();
            const showId = location?.state?.showId || location?.state?.showDetails?.show_id;
            const response = await getVideoDetails(vanityUrl, appInfo, showId);
            if (response?.status === 200) {
                setMultiLanguageOptions(response.data.data.audio_languages);
                setVideoDetails(response?.data?.data);
                setVideoTitle(response?.data?.data?.video_title)
                setPoster(response?.data?.data?.thumbnail_350_200)
                setUpNext(response?.data?.data?.up_next)
                setLoading(false)
                if (response?.data?.data?.watchlist_flag === 1) {
                    setWatchListStatus("added");
                } else {
                    setWatchListStatus("removed");
                }
                if (response?.data?.data?.watched_duration > 0 && !continueWatch) {
                    setIsContinueWatchingModal(true);
                }
            } else if (response?.status === 401) {
                navigate("/login", {
                    state: {
                        ...location.state,
                        path: location?.pathname,
                        showId: showId,
                        isFrom: true
                    }
                });
            } else if (response?.status === 403) {
                if (projectInfo?.projectConfig?.config?.WEBSITE_NEW_CHECKOUT_REQUIRED === 'true') {
                    navigate("/checkout", {
                        state: { videoId: videoId }
                    });
                } else {
                    navigate("/subscription", {
                        state: { videoId: videoId }
                    });
                }
            }
        } catch (err) {
            setLoading(false);
        }
    };
    const multiLanguageDropdownHandler = async (selectedOption) => {
        setSelectedAudioLanguage({ value: selectedOption.value, label: selectedOption.label, video_name: selectedOption.video_name })
        setWatchedTime(playerRef.current.currentTime())
        setVideoTitle(selectedOption.video_title)
        startPlaying(selectedOption.video_time, selectedOption.audio)
    }
    const tokenAuthenticate = async () => {
        const response = await authenticate(appInfo);
        if (response?.status === 200) {
            dispatch(
                getAccessToken({
                    accessToken: response?.data?.token,
                })
            );
        }
    };

    const logoutLimitCheck = () => {
        if (userSubscriptionData?.forcibleLogout === true) {
            setLogoutModal(true);
            setModalType({
                type: "logoutAll",
                heading: "You’ve reached the maximum Device limit.Do you want to logout from all devices",
            });
            return true;
        } else if (userSubscriptionData?.session_expired === true) {
            setModalType({ type: "redirect" });
            setLogoutModal(true);
            setTimeout(() => {
                handleClose();
                redirectToLogin();
            }, 1000);
            return true;
        }
        return false;
    }

    const playVideo = async (watchedLength) => {
        setShowVideo(true);
        if (watchedLength) {
            setWatchedDuration(watchedLength);
        }
        setSubTitleInfo(videoDetails?.subtitles);
        setVideoResolutionInfo(videoDetails?.resolutions);
        setClosedCaptionInfo(videoDetails?.closed_captions);
        const arr = videoDetails?.video_name?.split("/").reverse();
        const audio = videoDetails?.audio;
        const videoTime = videoDetails?.video_time;
        startPlaying(videoTime, audio);
    }

    const startPlaying = async (videoTime, audio) => {

        if (videoTime) {
            const playerTokenData = await fetchPlayerToken(videoTime);

            if (playerTokenData) {
                setVPlayer(null);
                if (audio) {
                    setVideoUrl(
                        "https://api.gizmott.com/api/v1/playlistV2/playlist.m3u8?id=" +
                        videoTime +
                        "&token=" +
                        playerTokenData +
                        "&type=" +
                        videoType +
                        "&pubid=" +
                        projectInfo?.projectConfig?.pubid +
                        "&audio=" + audio
                    );
                } else {
                    setVideoUrl(
                        "https://api.gizmott.com/api/v1/playlistV2/playlist.m3u8?id=" +
                        videoTime +
                        "&token=" +
                        playerTokenData +
                        "&type=" +
                        videoType +
                        "&pubid=" +
                        projectInfo?.projectConfig?.pubid
                    );
                }

            }
        }
    }

    const fetchPlayerToken = async (videoId) => {
        const playerTokenResponse = await getPlayerToken(appInfo, videoId);
        if (playerTokenResponse?.status === 200) {
            return playerTokenResponse?.data?.data;
        }
    };

    const handlePlayerReady = (player) => {
        playerRef.current = player;
        document.addEventListener('keydown', function (event) {
            if (event.key === 'Enter' && !player.isFullscreen()) {
                player.requestFullscreen().catch((error) => {
                    console.warn('Could not enter fullscreen:', error);
                });
            }
        });
        player.on("play", () => {
            let event = null;
            if (!videoStarted) {
                // First play
                event = "POP02";
                videoStarted = true;
            } else if (wasPaused) {
                // Resume from pause
                event = "POP09";
            }
            videoPlaying = true;
            if (event) {
                if (ai_type) {
                    updateVideoAnalytics(event, player.currentTime(), ai_type);
                } else {
                    updateVideoAnalytics(event, player.currentTime());
                }
            }
            playEventSent = true;
            wasPaused = false;
        });
        player.on("loadedmetadata", () => {
            // player.pause();
            if (watchedTime > 0) {
                player.currentTime(watchedTime.toString());
                if (player.paused()) player.play();
                videoPlaying = true;
            } else if (watchedDuration > 0) {
                player.currentTime(watchedDuration.toString());
                if (player.paused()) player.play();
                videoPlaying = true;
            } else {
                if (player.paused()) player.play();
                videoPlaying = true;
            }
            // if (ai_type) {
            //     updateVideoAnalytics("POP02", player.currentTime(), ai_type);
            // } else {
            //     updateVideoAnalytics("POP02", player.currentTime());
            // }
        });
        player.on("timeupdate", function (e) {
            let event = "POP03";
            videoPlaying = true;
            var hasPlayedTime = player.currentTime();
            var intPlayedTime = parseInt(hasPlayedTime, 10);
            var isSixty = intPlayedTime % seconds === 0 && intPlayedTime !== 0;
            if (isSixty && debounce) {
                debounce = false;
                prevTime = intPlayedTime;
                if (ai_type) {
                    updateVideoAnalytics(event, player.currentTime(), ai_type);
                } else {
                    updateVideoAnalytics(event, player.currentTime());
                }
            } else {
                if (debounce == false && prevTime != intPlayedTime) {
                    debounce = true;
                }
            }
        });

        player.on("pause", () => {
            // Prevent duplicate POP04 events
            if (!wasPaused) {
                let event = "POP04";
                videoPlaying = true;
                wasPaused = true;
                // POP04 is for pause event
                if (ai_type) {
                    updateVideoAnalytics(event, player.currentTime(), ai_type);
                } else {
                    updateVideoAnalytics(event, player.currentTime());
                }
            }
        });
        player.on("ended", () => {
            let event = "POP05";
            videoPlaying = false;
            playEventSent = false;
            wasPaused = false;
            // episodeCount = findIndex() + 1;
            if (ai_type) {
                updateVideoAnalytics(event, player.currentTime(), ai_type);
            } else {
                updateVideoAnalytics(event, player.currentTime());
            }
            // Autoplay logic commented for now
            // if (videoDetails?.video_type === "playlist") {
            //     const currentIndex = videoDetails.up_next.findIndex(
            //         (video) => video.video_id === videoDetails.video_id
            //     );

            //     if (currentIndex < videoDetails.up_next.length - 1) {
            //         setIsAutoplayView(true);
            //     }
            // }

            // if (videoDetails?.video_type !== "playlist" && videoDetails?.up_next?.length > 0) {
            //     setIsAutoplayView(true);
            // }
        });
        player.on("dispose", () => {
            videoPlaying = false;
            videoStarted = false;
            playEventSent = false;
            wasPaused = false;
            player.pause();
        });
        player.on('keydown', (e) => {
            if (e.which === 32 || e.which === 13) {
                e.preventDefault();
                if (player.paused()) {
                    player.play();
                } else {
                    player.pause();
                }
            }
        });

        player.on('keydown', (e) => {
            if (e.which === 37) {
                e.preventDefault();
                player.currentTime(player.currentTime() - 10);
            } else if (e.which === 39) {
                e.preventDefault();
                player.currentTime(player.currentTime() + 10);
            }
        });
        player.on('keydown', (e) => {
            if (e.which === 70 || e.which === 102) {
                e.preventDefault();
                player.requestFullscreen();
            }
        });

        player.on('keydown', (e) => {
            if (e.which === 38) {
                e.preventDefault();
                player.volume(player.volume() + 1);
            } else if (e.which === 40) {
                e.preventDefault();
                player.volume(player.volume() - 0.1);
            }
        });

        player.on('keydown', (e) => {
            if (e.which === 77 || e.which === 109) {
                e.preventDefault();
                player.muted(!player.muted());
            }
        });
        player.ready(() => {
            player.el().focus();
        });
    };

    const goBack = () => {
        if (location?.state?.backURL) {
            navigate(location.state.backURL);
        } else {
            navigate(-1);
        }

    };

    const searchHandler = (value, type) => {
        navigate(`/search?query=${value}`, { state: { type } });
    };

    const navigateToCategoryShowsListing = (vanityUrl) => {
        navigate(`/category/${vanityUrl}`, { state: { careers: vanityUrl } })
    }

    const handlePlaylistVideoChange = async (newVideo) => {
        setVPlayer(null);

        try {
            const showId = location?.state?.showId || location?.state?.showDetails?.show_id;
            const response = await getVideoDetails(newVideo.vanity_url, appInfo, showId);

            if (response?.status === 200) {
                const freshVideoData = {
                    ...response.data.data,
                    video_type: 'playlist',
                    vanity_url: response.data.data.vanity_url || newVideo.vanity_url
                };

                setVideoDetails(freshVideoData);
                setVideoTitle(freshVideoData.video_title);
                setPoster(freshVideoData.thumbnail_350_200);
                setWatchedTime(0);
                setWatchedDuration(0);
                setUpNext(freshVideoData.up_next || []);
                setMultiLanguageOptions(freshVideoData.audio_languages || []);
                setSubTitleInfo(freshVideoData.subtitles);
                setClosedCaptionInfo(freshVideoData.closed_captions);

                const vanityUrl = freshVideoData.vanity_url || newVideo.vanity_url;
                window.history.replaceState(
                    { videoDetails: freshVideoData },
                    '',
                    `/videos/${vanityUrl}`
                );

                const videoTime = freshVideoData?.video_time || 0;
                const audio = freshVideoData?.audio;
                startPlaying(videoTime, audio);
            }
        } catch (error) {
            console.error("Error fetching video details:", error);

            const updatedVideo = {
                ...newVideo,
                video_type: 'playlist'
            };

            setVideoDetails(updatedVideo);
            setVideoTitle(updatedVideo.video_title);
            setPoster(updatedVideo.thumbnail_350_200);

            const vanityUrl = updatedVideo.vanity_url || newVideo.vanity_url;
            window.history.replaceState(
                { videoDetails: updatedVideo },
                '',
                `/videos/${vanityUrl}`
            );

            const videoTime = updatedVideo?.video_time || 0;
            const audio = updatedVideo?.audio;
            startPlaying(videoTime, audio);
        }
    }

    if (loading) {
        return <Loading />;
    }
    return (
        <div className='videoPlayerContainer' role="main" aria-label="Video Player Page">
            <div className='wrapper'>
                {!continueWatch && isContinueWatchingModal && (
                    <ContinueWatchingModel
                        setIsContinueWatchingModal={setIsContinueWatchingModal}
                        videoDetails={videoDetails}
                        playVideo={playVideo}
                        showDetails={showDetails}
                        appInfo={appInfo}
                        setAdUrl={setAdUrl}
                    />
                )}
                {logoutModal && (
                    <LogoutAllModal
                        showId={showUniqueId}
                        appInfo={appInfo}
                        setLogoutModal={setLogoutModal}
                        modalType={modalType}
                        videoDetails={videoDetails}
                        handleClose={handleClose}
                    />
                )}
                <div className="arrowContainer" onClick={goBack} role="button" tabIndex={0} aria-label="Go Back" onKeyDown={e => { if (e.key === 'Enter' || e.key === ' ') { goBack(); } }}>
                    <h3>
                        <LeftArrow />
                    </h3>
                </div>
                <div className={`topContainer ${videoDetails?.video_type === 'playlist' ? "playlist" : ""}`} aria-label="Video Player Section">
                    <div className={`playerContainer ${videoDetails?.video_type === 'playlist' ? "playlist" : ""}`} aria-label="Video Player">
                        {!isContinueWatchingModal && vPlayer && (
                            <>
                                {videoDetails?.watermark && (
                                    <img
                                        src={videoDetails.watermark}
                                        alt="Watermark"
                                        className="watermark"
                                    />
                                )}
                                {vPlayer}
                            </>
                        )}
                        {
                            isAutoplayView &&
                            <Autoplay episodes={videoDetails?.up_next} setIsAutoplayView={setIsAutoplayView} isPlaylist={videoDetails?.video_type === 'playlist'} onVideoChange={handlePlaylistVideoChange} currentVideoId={videoDetails?.video_id} season={videoDetails?.season} template={template} thumbnailOrientation={thumbnailOrientation} />
                        }
                    </div>
                    {videoDetails?.video_type === 'playlist' && (
                        <div className="upNextSidebar" role="region" aria-label="Up Next Playlist">
                            {Array.isArray(upNext) && upNext.length > 0 && upNext[0]?.season && upNext[0]?.videos ? (
                                <div className="upNextList">
                                    {upNext.map((seasonObj, sIdx) => (
                                        <div key={seasonObj.season || sIdx} className="upNextSeasonGroup">
                                            <h2 className="seasonHeading">{seasonObj.season}</h2>
                                            {seasonObj.videos?.map((video) => (
                                                <div
                                                    className={`upNextItem ${video.video_id === videoDetails.video_id ? "selected" : ""}`}
                                                    key={video.video_id}
                                                    onClick={() => handlePlaylistVideoChange(video)}
                                                    role="button"
                                                    tabIndex={0}
                                                    aria-label={`Play ${video.video_title}`}
                                                    onKeyDown={e => { if (e.key === 'Enter' || e.key === ' ') { handlePlaylistVideoChange(video); } }}
                                                >
                                                    <div className='upNextTop'>
                                                        <div className={`upNextThumbnail${video.challenge_completed ? ' blurred' : ''}`}>
                                                            <img
                                                                src={video.thumbnail_350_200}
                                                                alt={video.video_title}
                                                            />
                                                            {video.challenge_completed && (
                                                                <span className="challenge-completed-indicator" title="Completed">
                                                                    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" width="16" height="16">
                                                                        <path d="M5 13L9 17L20 8" stroke="white" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" />
                                                                    </svg>
                                                                </span>
                                                            )}
                                                        </div>
                                                        <div className="metaData">
                                                            <div className="upNextTitle">
                                                                {video?.video_title}
                                                            </div>
                                                            <div className="upNextDuration">
                                                                {video?.duration_text}
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className={`upNextDescription ${video.video_id === videoDetails.video_id ? "visible" : ""}`}>
                                                        {isHTML(video?.video_description)
                                                            ? <span dangerouslySetInnerHTML={{ __html: video?.video_description }} />
                                                            : video?.video_description}
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    ))}
                                </div>
                            ) : (
                                <>
                                    <h1 className="heading">
                                        {upNext?.length} <Translate textKey={'videos'} />
                                    </h1>
                                    <div className="upNextList">
                                        {upNext?.map((video) => (
                                            <div
                                                className={`upNextItem ${video.video_id === videoDetails.video_id ? "selected" : ""}`}
                                                key={video.id}
                                                onClick={() => handlePlaylistVideoChange(video)}
                                                role="button"
                                                tabIndex={0}
                                                aria-label={`Play ${video.video_title}`}
                                                onKeyDown={e => { if (e.key === 'Enter' || e.key === ' ') { handlePlaylistVideoChange(video); } }}
                                            >
                                                <div className='upNextTop'>
                                                    <div className="upNextThumbnail">
                                                        <img
                                                            src={video.thumbnail_350_200}
                                                            alt={video.video_title}
                                                        />
                                                    </div>
                                                    <div className="metaData">
                                                        <div className="upNextTitle">
                                                            {video?.video_title}
                                                        </div>
                                                        <div className="upNextDuration">
                                                            {video?.duration_text}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className={`upNextDescription ${video.video_id === videoDetails.video_id ? "visible" : ""}`}>
                                                    {isHTML(video?.video_description)
                                                        ? <span dangerouslySetInnerHTML={{ __html: video?.video_description }} />
                                                        : video?.video_description}
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </>
                            )}
                        </div>
                    )}
                </div>
                <div className="multiAudio" aria-label="Audio Language Selection">
                    {multiLanguageOptions?.length > 1 &&
                        <div className="selectContainer">
                            <Select
                                styles={customStyles}
                                options={multiLanguageOptions.map((video) => ({
                                    value: video.language_name,
                                    label: video.language_name,
                                    video_name: video.video_name,
                                    video_title: video.video_title,
                                    video_time: video.video_time,
                                    audio: video.audio
                                }))}
                                placeholder={multiLanguageOptions[0]?.language_name}
                                onChange={multiLanguageDropdownHandler}
                                value={selectedAudioLanguage && Object.keys(selectedAudioLanguage)?.length !== 0 ? selectedAudioLanguage : null}
                                aria-label="Select audio language"
                            />
                        </div>}
                </div>

                <div className="videoMetaData" aria-label="Video Metadata">
                    <div className="head">
                        <h1 className="videoTitle">{videoTitle}</h1>
                    </div>
                    <div className="categoriesAndRating">
                        <div className="categories">
                            {template === "TEMPLATE_9" && videoDetails?.categories?.map((item, index) => (
                                <span className="category" onClick={() => { navigateToCategoryShowsListing(item?.key) }} role="button" tabIndex={0} aria-label={`View category ${item?.category_name}`} onKeyDown={e => { if (e.key === 'Enter' || e.key === ' ') { navigateToCategoryShowsListing(item?.key); } }}>{item?.category_name}</span>
                            ))}
                        </div>

                    </div>

                    {videoDetails?.go_ads_free && (
                        <div className="watchNow">
                            <button
                                onClick={() => {
                                    if (projectInfo?.projectConfig?.config?.WEBSITE_NEW_CHECKOUT_REQUIRED === 'true') {
                                        navigate("/checkout", { state: { videoId: videoDetails?.video_id, is_go_ad_free: true } });
                                    } else {
                                        navigate("/subscription", { state: { videoId: videoDetails?.video_id, is_go_ad_free: true } });
                                    }
                                }}
                            >
                                <Translate textKey={'go_ads_free'} />
                            </button>
                        </div>
                    )}

                    <div className="calendarActions">
                        <button
                            className="add-to-calendar-btn"
                            onClick={() => setShowCalendarPopup(true)}
                            aria-label="Add to Calendar"
                        >
                            <svg width="24px" height="24px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="calendar-icon">
                                <g strokeWidth="0"></g>
                                <g strokeLinecap="round" strokeLinejoin="round"></g>
                                <g>
                                    <path fillRule="evenodd" clipRule="evenodd" d="M7 1C6.44772 1 6 1.44772 6 2V3H5C3.34315 3 2 4.34315 2 6V20C2 21.6569 3.34315 23 5 23H13.101C12.5151 22.4259 12.0297 21.7496 11.6736 21H5C4.44772 21 4 20.5523 4 20V11H20V11.2899C20.7224 11.5049 21.396 11.8334 22 12.2547V6C22 4.34315 20.6569 3 19 3H18V2C18 1.44772 17.5523 1 17 1C16.4477 1 16 1.44772 16 2V3H8V2C8 1.44772 7.55228 1 7 1ZM16 6V5H8V6C8 6.55228 7.55228 7 7 7C6.44772 7 6 6.55228 6 6V5H5C4.44772 5 4 5.44772 4 6V9H20V6C20 5.44772 19.5523 5 19 5H18V6C18 6.55228 17.5523 7 17 7C16.4477 7 16 6.55228 16 6Z" fill="currentColor"></path>
                                    <path d="M17 16C17 15.4477 17.4477 15 18 15C18.5523 15 19 15.4477 19 16V17H20C20.5523 17 21 17.4477 21 18C21 18.5523 20.5523 19 20 19H19V20C19 20.5523 18.5523 21 18 21C17.4477 21 17 20.5523 17 20V19H16C15.4477 19 15 18.5523 15 18C15 17.4477 15.4477 17 16 17H17V16Z" fill="currentColor"></path>
                                    <path fillRule="evenodd" clipRule="evenodd" d="M24 18C24 21.3137 21.3137 24 18 24C14.6863 24 12 21.3137 12 18C12 14.6863 14.6863 12 18 12C21.3137 12 24 14.6863 24 18ZM13.9819 18C13.9819 20.2191 15.7809 22.0181 18 22.0181C20.2191 22.0181 22.0181 20.2191 22.0181 18C22.0181 15.7809 20.2191 13.9819 18 13.9819C15.7809 13.9819 13.9819 15.7809 13.9819 18Z" fill="currentColor"></path>
                                </g>
                            </svg>
                            <Translate textKey={'add_to_calendar'}/>
                        </button>
                    </div>

                    <p className="description">
                        {template === "TEMPLATE_9" && videoDetails?.video_description && (
                            isHTML(videoDetails?.video_description)
                                ? <span dangerouslySetInnerHTML={{ __html: videoDetails?.video_description }} />
                                : videoDetails?.video_description
                        )}
                    </p>

                    <div className="extraInfoContainer">
                        {videoDetails?.video_tags?.length > 0 && template === "TEMPLATE_9" && (
                            <div className="metaItem">
                                <h6 className="subHeading"><Translate textKey={'tags'} /></h6>
                                <div className="items oneRow">
                                    {videoDetails?.video_tags?.length > 0 &&
                                        videoDetails?.video_tags?.map((item, index) => (
                                            <span className="item" onClick={() => searchHandler(item, "tags")} role="button" tabIndex={0} aria-label={`Search tag ${item}`} onKeyDown={e => { if (e.key === 'Enter' || e.key === ' ') { searchHandler(item, "tags"); } }}>
                                                {item}
                                                <span className="comma">,</span>
                                            </span>
                                        ))}
                                </div>
                            </div>
                        )}
                        {videoDetails?.cast?.length > 0 && template === "TEMPLATE_9" && (
                            <div className="metaItem">
                                <h6 className="subHeading"><Translate textKey={'cast'} /></h6>
                                <div className="items">
                                    {videoDetails?.cast?.map((item, index) => (
                                        <div className="item" key={item?.id}>
                                            <span className="itemInfo" onClick={() => searchHandler(item?.name, "cast")} role="button" tabIndex={0} aria-label={`Search cast ${item?.name}`} onKeyDown={e => { if (e.key === 'Enter' || e.key === ' ') { searchHandler(item?.name, "cast"); } }}>
                                                {item?.name}
                                            </span>
                                            <span className="itemLabel">{item?.role}</span>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        )}
                        {videoDetails?.crew?.length > 0 && template === "TEMPLATE_9" && (
                            <div className="metaItem">
                                <h6 className="subHeading"><Translate textKey={'crew'} /></h6>
                                <div className="items">
                                    {videoDetails?.crew?.map((item, index) => (
                                        <div className="item" key={item?.id}>
                                            <span className="itemInfo" onClick={() => searchHandler(item?.name, "crew")} role="button" tabIndex={0} aria-label={`Search crew ${item?.name}`} onKeyDown={e => { if (e.key === 'Enter' || e.key === ' ') { searchHandler(item?.name, "crew"); } }}>
                                                {item?.name}
                                            </span>
                                            <span className="itemLabel">{item?.role}</span>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        )}
                    </div>
                </div>

                <div>
                    {upNext?.length > 0 && videoDetails?.video_type !== 'playlist' && videoDetails?.season && (
                        <div className="upNextContainer" role="region" aria-label="Up Next">
                            <h1 className="heading"><Translate textKey={'upnext'} /> {videoDetails?.season && (<>{' '}<Translate textKey={'inseason'} />{' '}{videoDetails?.season}</>)} </h1>
                            <div className="upNext" onClick={() => setIsAutoplayView(false)}>
                                {upNext?.map((video, index) => (
                                    <div className={(thumbnailOrientation === "PORTRAIT" || projectInfo?.projectConfig?.config?.THUMBNAIL_ORIENTATION === "PORTRAIT") ? "itemPortrait" : "item"} key={video.id + index} role="button" tabIndex={0} aria-label={`Play ${video.video_title}`} onKeyDown={e => { if (e.key === 'Enter' || e.key === ' ') { setIsAutoplayView(false); } }}>
                                        {(<ShowCard data={video} type="Episode" thumbnailOrientation={thumbnailOrientation} />)}
                                    </div>
                                ))}
                            </div>
                        </div>
                    )}
                </div>

                {projectInfo?.projectConfig?.config?.COMMENTS_REQUIRED === "true" && projectInfo?.projectConfig?.config?.WEBSITE_FIREBASE_JSON_FILE &&
                    <div className="wrapper" aria-label="Comments Section">
                        <Comment videoId={videoDetails?.video_id} projectInfo={projectInfo} />
                    </div>
                }

            </div>

            <CalendarPopup
                isOpen={showCalendarPopup}
                onClose={() => setShowCalendarPopup(false)}
                initialDate={new Date()}
                videoId={videoDetails?.video_id}
                appInfo={appInfo}
            />
        </div>
    )
}

export default VideoPlayer
